import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { ChatProvider } from "./context/ChatContext";
import { SettingsProvider } from "./context/SettingsContext";
import {
  LoginOverlayProvider,
  useLoginOverlay,
} from "./context/LoginOverlayContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import More from "./pages/More";
import Explore from "./pages/Explore";
import Login from "./pages/Login";
import "./App.css";

// Wrapper component that provides navigation to NotificationProvider
const AppContent = () => {
  const navigate = useNavigate();
  const { loading, token } = useAuth();
  const { showLoginSheet, setShowLoginSheet } = useLoginOverlay();
  const [hasCheckedToken, setHasCheckedToken] = useState(false);

  useEffect(() => {
    if (loading || hasCheckedToken) {
      return;
    }

    const storedToken = localStorage.getItem("authToken");
    const storedPhone = localStorage.getItem("phoneNumber");
    
    // Show overlay if no token OR phoneNumber is "Guest"
    if (!storedToken || storedPhone === "Guest") {
      setShowLoginSheet(true);
    }

    setHasCheckedToken(true);
  }, [loading, hasCheckedToken, setShowLoginSheet]);

  useEffect(() => {
    const storedPhone = localStorage.getItem("phoneNumber");
    // Hide overlay only if token exists AND phoneNumber is not "Guest"
    if (token && storedPhone !== "Guest") {
      setShowLoginSheet(false);
    }
  }, [token, setShowLoginSheet]);

  return (
    <SettingsProvider>
      <NotificationProvider navigate={navigate}>
        <ChatProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route
                      path="/navigate"
                      element={
                        <More
                          placeholderText="Navigate Page (Coming Soon)"
                          title="Navigate Content"
                        />
                      }
                    />
                    <Route
                      path="/explore"
                      element={
                        <Explore
                          placeholderText="Explore Page (Coming Soon)"
                          title="Explore Content"
                        />
                      }
                    />
                    <Route
                      path="/commute"
                      element={
                        <div style={{ padding: "20px", textAlign: "center" }}>
                          Commute Page (Coming Soon)
                        </div>
                      }
                    />
                    <Route path="/more" element={<More />} />
                  </Routes>
                  <Login
                    asBottomSheet
                    isOpen={showLoginSheet}
                    onClose={() => setShowLoginSheet(false)}
                  />
                </Layout>
              }
            />
          </Routes>
        </ChatProvider>
      </NotificationProvider>
    </SettingsProvider>
  );
};

function App() {
  return (
    <div className="app">
      <Router>
        <AuthProvider>
          <LoginOverlayProvider>
            <AppContent />
          </LoginOverlayProvider>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
